/* eslint-disable no-warning-comments */

import ausJson from './data/AUS.simple.geo.json'
import canJson from './data/CAN.simple.geo.json'
import usaJson from './data/gs48.USA.simple.geo.json'
import usaSpecialAreas from './data/usaSpecialAreas.json'
import worldJson from './data/world.simple.geo.json'
import initialAUMapData from './data/initialAuData.json'
import initialCAMapData from './data/initialCaData.json'
import initialUSMapData from './data/initialUsData.json'
import initialWorldMapData from './data/initialWorldData.json'

import { toHslaString } from 'shared/mappers'

export const getItemStyle = (color: ColorHsla) => {
    const borderColor = toHslaString(color)
    return {
        normal: {
            borderColor,
            borderWidth: 1,
        },
        emphasis: {
            label: {
                show: false,
            },
            areaColor: null,
            borderColor,
            borderWidth: 2,
        },
    }
}

export const setGradientMapBoudaryLookup = (state: MapVisualizer, data: any) => {
    const wasGradientMapBoundaryLookupSet = Object.keys(state.gradientMapBoundaryLookup).length > 0
    if (!wasGradientMapBoundaryLookupSet) {
        // const boundaries: ViewMapDataRecord[] = data
        return {
            ...state,
            gradientMapBoundaryLookup: data.reduce((acc: any, v: any) => {
                acc[v.code] = v.name
                return acc
            }, {}),

        }
    }
    return state
}

export const getMap = (payload: GenerateMapPayload): EchartsMapOptions => {
    switch (payload.scoreboardTypeId) {
        case 1:
            return {
                kind: getMapKind(payload),
                geoJson: getSelectedStates(payload),
                specialAreas: usaSpecialAreas,
                aspectRatio: (505 / 800),
            }
        case 2:
            return {
                kind: 'World',
                geoJson: worldJson,
                specialAreas: {},
                boundingCoords: [[-11000000, 7000000], [13200000, -7500000]],
                aspectRatio: (437 / 800),
            }
        case 3:
            return {
                kind: 'CAN',
                geoJson: canJson,
                specialAreas: {},
                aspectRatio: (630 / 800),
            }
        case 4:
            return {
                kind: 'AUS',
                geoJson: ausJson,
                specialAreas: {},
                aspectRatio: (674 / 800),
            }
        default:
            return {
                kind: 'Unknown',
                geoJson: null,
                specialAreas: null,
                aspectRatio: 0,
            }
    }
}

export const getMapDataSource = (scoreboardTypeId: number) => {
    switch (scoreboardTypeId) {
        case 1: return { data: initialUSMapData, label: 'State' }
        case 2: return { data: initialWorldMapData, label: 'Country' }
        case 3: return { data: initialCAMapData, label: 'State' }
        case 4: return { data: initialAUMapData, label: 'State' }
        default:
            throw new Error('Unrecognized Scoreboard Type Id')
    }
}

// TODO: These types are probably wrong
export const populate = (payload: MapDataItem[], initialDataSet: any): ViewMapDataRecord[] => {
    const mapData: ViewMapDataRecord[] = initialDataSet
    const newData: ViewMapDataRecord[] = []

    for (const oldRecord of mapData) {
        const newRecord = { ...oldRecord }
        const payloadRecord = payload.find((x: any) => x.name === newRecord.code)
        if (payloadRecord !== undefined) {
            newRecord.donors = payloadRecord.recordCount
            newRecord.value = payloadRecord.totalDollars
        }
        newData.push(newRecord)
    }
    return newData
}

export const getSelectedStates = (payload: GenerateMapPayload) => {
    if (payload.customizeStates) {
        let name = ''
        const json: GeoJson = {
            type: 'FeatureCollection',
            name: '',
            crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
            features: [],
        }
        for (const stateId of payload.selectedStates) {
            const state = stateIds.filter(x => x.id === stateId)
            name += state[0].name
            const jsonState = (usaJson as GeoJson).features.filter(x => x.properties.name === state[0].name)[0]
            json.features.push(jsonState)
        }
        json.name = name
        return json
    }
    return usaJson

}

const getMapKind = (payload: GenerateMapPayload) => {
    let name = ''
    if (payload.customizeStates) {
        for (const stateId of payload.selectedStates) {
            const state = stateIds.filter(x => x.id === stateId)
            name += state[0].name
        }
    } else {
        name = 'USA'
    }
    return name
}

const stateIds = [
    { id: 1, name: 'Alabama' },
    { id: 2, name: 'Alaska' },
    { id: 3, name: 'Arizona' },
    { id: 4, name: 'Arkansas' },
    { id: 5, name: 'California' },
    { id: 6, name: 'Colorado' },
    { id: 7, name: 'Connecticut' },
    { id: 8, name: 'Delaware' },
    { id: 9, name: 'District of Columbia' },
    { id: 10, name: 'Florida' },
    { id: 11, name: 'Georgia' },
    { id: 12, name: 'Hawaii' },
    { id: 13, name: 'Idaho' },
    { id: 14, name: 'Illinois' },
    { id: 15, name: 'Indiana' },
    { id: 16, name: 'Iowa' },
    { id: 17, name: 'Kansas' },
    { id: 18, name: 'Kentucky' },
    { id: 19, name: 'Louisiana' },
    { id: 20, name: 'Maine' },
    { id: 21, name: 'Maryland' },
    { id: 22, name: 'Massachusetts' },
    { id: 23, name: 'Michigan' },
    { id: 24, name: 'Minnesota' },
    { id: 25, name: 'Mississippi' },
    { id: 26, name: 'Missouri' },
    { id: 27, name: 'Montana' },
    { id: 28, name: 'Nebraska' },
    { id: 29, name: 'Nevada' },
    { id: 30, name: 'New Hampshire' },
    { id: 31, name: 'New Jersey' },
    { id: 32, name: 'New Mexico' },
    { id: 33, name: 'New York' },
    { id: 34, name: 'North Carolina' },
    { id: 35, name: 'North Dakota' },
    { id: 36, name: 'Ohio' },
    { id: 37, name: 'Oklahoma' },
    { id: 38, name: 'Oregon' },
    { id: 39, name: 'Pennsylvania' },
    { id: 40, name: 'Puerto Rico' },
    { id: 41, name: 'Rhode Island' },
    { id: 42, name: 'South Carolina' },
    { id: 43, name: 'South Dakota' },
    { id: 44, name: 'Tennessee' },
    { id: 45, name: 'Texas' },
    { id: 46, name: 'Utah' },
    { id: 47, name: 'Vermont' },
    { id: 48, name: 'Virginia' },
    { id: 49, name: 'Washington' },
    { id: 50, name: 'West Virginia' },
    { id: 51, name: 'Wisconsin' },
    { id: 52, name: 'Wyoming' },
]
